export const CustomStyle ={
    buttonStyle: "text-white border border-blue-700 bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-14 py-2.5 text-center mb-2",
    test: "block w-full bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-3 px-3 block appearance-none leading-normal focus:border-blue-400",
    mainHeading:"text-base font-semibold mb-2",
    containedButtonStyle :"text-sm font-sans capitalize font-normal",
    viewPageText: "text-sm font-sans break-words",
    borderedDiv :"border-b pb-2",
    viewPageGrid : "grid md:grid-cols-2 xl:grid-cols-2 gap-5 mt-4"
}